import request from '@/utils/request'
import qs from 'qs'
export function getListReservationReport(query) {
  return request({
    url: '/report-service/v1/report/arriving-booking',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getListReservationReportExcel(query) {
  return request({
    url: '/report-service/v1/report/arriving-booking/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
export function getAllSales() {
  return request({
    url: '/config-service/v1/account',
    method: 'get',
    params: {
      department: 'SALE'
    }
  })
}

export function getAllFO() {
  return request({
    url: '/config-service/v1/account',
    method: 'get',
    params: {
      department: 'FO'
    }
  })
}
